<div class="preview-container">
    <file-thumbnail class="preview" [file]="entry"></file-thumbnail>
</div>
<figcaption class="files-grid-item-footer">
    <file-icon [type]="entry.type"></file-icon>
    <div class="text">{{entry.name}}</div>
</figcaption>